import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { DialogActionsComponent } from '@ui/Components/Dialog/DialogActions.Component'
import { NgStyle } from '@angular/common'
import { ButtonComponent } from '@ui/Components/Form/Button/Button.Component'

@Component({
	selector: 'delete-dialog',
	templateUrl: './ConfirmDeleteDialog.Component.html',
	imports: [DialogComponent, DialogActionsComponent, NgStyle, ButtonComponent],
})
export class ConfirmDeleteDialogComponent {
	private readonly dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>

	constructor() {
		this.dialogRef = inject(MatDialogRef<ConfirmDeleteDialogComponent>)
	}

	public closeDialog = () => {
		this.dialogRef.close(false)
	}

	public confirmAndClose = () => {
		this.dialogRef.close(true)
	}
}
